import { createQueryAction } from "../actionCreators";
import { API } from "@thenounproject/lingo-core";

type Args = {
  spaceId: number;
};

export type FigmaIntegrationStatus = {
  auth?: {
    dateAdded: string;
    dateUpdated: string;
    figmaHandle: string;
    message: string;
    spaceId: number;
    status: "error" | "active";
    authType: "pat" | "oauth";
    tokenExpiresAt: string | null;
  };
};

const [useFigmaIntegrationStatus, fetchFigmaIntegrationStatus] = createQueryAction<
  Args,
  FigmaIntegrationStatus,
  FigmaIntegrationStatus
>({ entity: "spaces", action: "fetchFigmaStatus", denormalize: false }, async ({ args }) => {
  return await API.call<FigmaIntegrationStatus>({
    endpoint: `spaces/${args.spaceId}/figma`,
    method: "GET",
    normalize: false,
  });
});

export default useFigmaIntegrationStatus;
export { fetchFigmaIntegrationStatus };
